export default "__VITE_ASSET__MChZMV3j__"